import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import GoodsModal from './GoodsModal';
import ImgView from 'components/common/FileController/ImgView';
import { notification, Button, Descriptions, Input, Checkbox, Table, InputNumber } from 'antd';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';

@inject(({ goodsGroupStore }) => ({ 
  detailData: goodsGroupStore.detailData,
  onViewMode : goodsGroupStore.onViewMode,
  merGoodsGroupList : goodsGroupStore.merGoodsGroupList,
  delGoodsGroupList : goodsGroupStore.delGoodsGroupList,

}))
@observer
class GoodsGroupDetail extends Component {
  state = {
    saveData: {
      groupCd: '',
      groupNm: '',
      groupOrder: '',
      useYn: 'Y',
      gdCdList: []
    },

    modalOpen: false
  };

  UNSAFE_componentWillMount() {
    if (this.props.detailData !== null) {
      this.setState({
        saveData: {
          ...this.state.saveData,
          ...this.props.detailData
        },
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.detailData !== this.props.detailData) {
      if (nextProps.detailData === null) {
        this.setState({
          saveData: {
            groupCd: '',
            groupNm: '',
            groupOrder: '',
            useYn: 'Y',
            gdCdList: []
          },
        });
      } else {
        this.setState({
          saveData: {
            ...this.state.saveData,
            ...nextProps.detailData
          },
        });
      }
    }
  }

  onChangValue = (dataVal, dataNm) => {
    this.setState({
      saveData: {
        ...this.state.saveData,
        [dataNm]: dataVal
    }});
  };

  handleOrderChange = (type, item, record, index) => {
    const newData = [...this.state.saveData.gdCdList];

    if (type === 'up') {
      newData.splice(index, 1, newData[index-1]);
      newData.splice(index-1, 1, record);
      
    } else if (type === 'down') {
      newData.splice(index, 1, newData[index+1]);
      newData.splice(index+1, 1, record);
    }

    this.setState({
      saveData: {
        ...this.state.saveData,
        gdCdList: newData
      }
    });
  };

  handleSave = () => {
    if (this.state.saveData.groupNm === '') {
      notification.warning({placement: 'bottomLeft', message: `상품군명을 입력해주세요.`, duration: 2});
      return false;
    }

    if (this.state.saveData.groupOrder === '' || this.state.saveData.groupOrder === null) {
      notification.warning({placement: 'bottomLeft', message: `상품군 정렬순서를 입력해주세요.`, duration: 2});
      return false;
    }

    if (this.state.saveData.gdCdList.length <= 0) {
      notification.warning({placement: 'bottomLeft', message: `삼품을 1개 이상 선택해주세요.`, duration: 2});
      return false;
    }

    // 정렬 값을 넣는다.
    let vGdCdListArr = [];
    this.state.saveData.gdCdList.map((item, idx)=>{
      return ( vGdCdListArr.push({...item, gdOrder: idx+1}))
    });

    let vDelArr = [];
    let vMerArr = [];
    if (this.props.detailData !== null && this.props.detailData.gdCdList !== undefined && this.props.detailData.gdCdList !== null) {
      this.props.detailData.gdCdList.map((orgItme)=>{
        let boolDel = true;
        return(
          vGdCdListArr.map((chgItem)=>{ return (
            (orgItme.gdCd === chgItem.gdCd) &&
            (vMerArr.push(chgItem), boolDel = false)
          )}),
          (boolDel === true) && vDelArr.push(orgItme)
        )
      });
    }

    vGdCdListArr.map((chgItem)=>{
      let boolAdd = true;
      return (
        (this.props.detailData !== null && this.props.detailData.gdCdList !== undefined && this.props.detailData.gdCdList !== null) &&
          (this.props.detailData.gdCdList.map((orgItme)=>{return (
            (orgItme.gdCd === chgItem.gdCd) && (boolAdd = false)
          )})),
        (boolAdd === true) && vMerArr.push(chgItem)
      )
    });

    console.log("gdCdList", this.state.saveData.gdCdList);
    console.log("vGdCdListArr", vGdCdListArr);
    
    console.log("vMerArr", vMerArr);
    console.log("vDelArr", vDelArr);

    if (vMerArr.length > 0) {
      this.props.merGoodsGroupList({...this.state.saveData, gdCdList: vMerArr});
    }
    if (vDelArr.length > 0 ) {
      this.props.delGoodsGroupList({...this.state.saveData, gdCdList:vDelArr});
    }
  };

  handleDelete = key => {
    this.setState({
      saveData: {
        ...this.state.saveData,
        gdCdList: this.state.saveData.gdCdList.filter(item => item.gdCd !== key)
      }
    });
  };

  handleAdd = data => {
    let vArr = [];
    // 중복제거하고 추가한다.
    data.map(dataItem=>{ 
      let boolen = false;
      this.state.saveData.gdCdList.map(orgItem=>{return (
        (orgItem.gdCd === dataItem.gdCd) && (boolen = true)
      )})
      return(
        (boolen === false) && vArr.push((dataItem))
      )
    });

    // console.log("vArr", vArr);

    this.setState({
      saveData: {
        ...this.state.saveData,
        gdCdList: [
          ...this.state.saveData.gdCdList,
          ...vArr
        ]
      }
    });
  };

  render() {
    const { onViewMode } = this.props;
    const { saveData, modalOpen } = this.state;
    const columns = [
      { title: '사진', dataIndex: 'imgUrl', width: '20%',
        render: (_, record) => { return(
          record?.gdImgUrlInfo_fileId &&
          <ImgView
            fileInfo={{
              fileId: record.gdImgUrlInfo_fileId,
              fileName: record.gdImgUrlInfo_fileName,
              physicalName: record.gdImgUrlInfo_physicalName,
              serverSubPath: record.gdImgUrlInfo_serverSubPath,
            }}
            width={50}
            height={50}
          />
        )}
      },
      { title: '상품명', dataIndex: 'gdNm', width: '25%' },
      { title: '성별', dataIndex: 'gdSex', width: '10%', align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item === "M" && <Fragment>남</Fragment>}
            {item === "F" && <Fragment>여</Fragment>}
            {item === "A" && <Fragment>공용</Fragment>}
          </Fragment>
        )}
      },
      { title: '판매가', dataIndex: 'gdPrice', width: '20%',
        render: (item, record) => { return(
          <Fragment>
            {item !== undefined && item !== null && item !== "" && item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </Fragment>
        )}
      },
      { title: '순서변경', dataIndex: '', width: '20%', align: 'center',
        render: (item, record, idx) => { return(
          <div key={record.gdCd}>
            {idx !== 0 &&
              <Button
                style={{ marginRight: 8 }}
                onClick={() => this.handleOrderChange('up', item, record, idx)}
              ><CaretUpOutlined /></Button>
            }
            {idx !== (this.state.saveData.gdCdList.length-1) &&
              <Button
                onClick={() => this.handleOrderChange('down', item, record, idx)}
              ><CaretDownOutlined /></Button>
            }
          </div>
        )}
      },
      { title: '삭제', dataIndex: '', key: '', width: '15%', align: 'center',
        render: (item, record, idx) => { return(
          <Fragment key={idx}>
            <Button
              onClick={() => this.handleDelete(record.gdCd)}
            >삭제</Button>
          </Fragment>
        )}
      }
    ];
    return (
      <Fragment>
        <div className="button-group">
          <h2>상품군 정보</h2>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <div style={{ color: 'red' }}>{process.env.REACT_APP_WARNING}</div>
          <div className="button-right">
            <ul>
              <li><Button type="primary" onClick={()=>onViewMode('list')}>목록</Button></li>
              <li><Button type="primary" onClick={this.handleSave}>저장</Button></li>
            </ul>
          </div>
        </div>
        <div className="table_th_W">
          <Descriptions bordered>
            <Descriptions.Item label="상품군명 *" span={1}>
              <Input
                style={{ width: '100%' }}
                value={saveData.groupNm}
                onChange={(e)=>this.onChangValue(e.target.value, 'groupNm')}
              />
            </Descriptions.Item>
            <Descriptions.Item label="정렬순서 *">
              <InputNumber
                value={saveData.groupOrder}
                min={1}
                onChange={(value)=>this.onChangValue(value, 'groupOrder')}
                style={{ width: 150 }}
              />
            </Descriptions.Item>
            <Descriptions.Item label="사용유무 *">
              <Checkbox 
                checked={saveData.useYn === 'Y' ? true : false}
                onChange={(e)=>this.onChangValue(e.target.checked ? 'Y' : 'N', 'useYn')}
              />
            </Descriptions.Item>
          </Descriptions>
          <span style={{ color: 'red' }}>※상품군 정렬순서가 같을 경우 먼저 등록된 순서로 정렬됩니다.</span>
        </div>
        <div className="button-group">
          <h2>▶ 상품</h2>
          <div className="button-right">
            <ul>
              <li><Button type="primary" onClick={()=>this.setState({modalOpen: true})}>상품추가</Button></li>
            </ul>
          </div>
        </div>
        <Table
          rowKey={(record)=>record.gdCd}
          columns={columns}
          dataSource={saveData.gdCdList}
          pagination={false}
          scroll={{ y: 700 }}
        />

        <GoodsModal
          modalOpen={modalOpen}
          modalClose={()=>this.setState({modalOpen: false})}
          setData={this.handleAdd}
        />

      </Fragment>
    );
    
  }
}

export default withRouter(GoodsGroupDetail);
